import { Nullable, Undefinedable } from "@/api/ApiClient";
import { ProductDataType } from "@/api/ProductsApi";
import { ProductExemptionDataType } from "./ProductExemptionDataType";

export type EDocumentProductDataType = Undefinedable<Nullable<{
    id?: string,
    codigo_cabys?: string,
    description: string,
    descriptionFact?: string,
    cant: number,
    cantFact?: number,
    price?: number,
    priceFact?: number,
    subtotal?: number,
    subtotalFact?: number,
    descuento: number,
    descuentoFact?: number,
    impuestos: number,
    impuestosFact?: number,
    impuestos_servicio?: number,
    impuestos_servicioFact?: number,
    porcentaje_descuento: number,
    tipo_producto: number,
    tipo_impuesto: string,
    porcentaje_impuesto: string,
    codigo_tarifa: string,
    unidad_medida: string,
    exemption?: ProductExemptionDataType | string;
    productId?: string,
    product?: ProductDataType,
    exento: boolean,
    codigo: string,
    partidaArancelaria?: string,
    comision?: number,
    orderIndex?: number,
    extraCost?: boolean,
    forceRecalculatePrice?: boolean
    preSavedId?: string,
    toDelete?: false,
    selected?: string,
    invoiceId?: string,
    invoice?: any,
    invoiceTemplateId?: string,
    invoiceTemplate?: any,
    quoteId?: string,
    quote?: any,
    creditnoteId?: string,
    creditnote?: any,
    debitnoteId?: string,
    debitnote?: any,
    settlementId?: string,
    settlement?: any,
    buyInvoiceId?: string,
    buyInvoice?: any,
    createdAt?: string,
    updatedAt?: string,
}>>;

export type ReportSummaryData = Undefinedable<Nullable<{
    totalCant?: number,
}>>

export type WithReportData<T extends object> = T & ReportSummaryData;

export const CreditNoteProductRelatedAttributes: Array<keyof EDocumentProductDataType> = ["preSavedId", "comision", "extraCost", "selected", "descriptionFact", "cantFact", "priceFact", "subtotalFact", "descuentoFact", "impuestosFact", "impuestos_servicioFact", "invoiceId", "invoice", "invoiceTemplateId", "invoiceTemplate", "quoteId", "quote", "settlementId", "settlement", "debitnoteId", "debitnote"];
export const DebitnoteProductRelatedAttributes: Array<keyof EDocumentProductDataType> = ["preSavedId", "comision", "extraCost", "selected", "descriptionFact", "cantFact", "priceFact", "subtotalFact", "descuentoFact", "impuestosFact", "impuestos_servicioFact", "invoiceId", "invoice", "invoiceTemplateId", "invoiceTemplate", "quoteId", "quote", "settlementId", "settlement", "creditnoteId", "creditnote"];
export const InvoiceProductRelatedAttributes: Array<keyof EDocumentProductDataType> = ["preSavedId", "comision", "extraCost", "selected", "descriptionFact", "cantFact", "priceFact", "subtotalFact", "descuentoFact", "impuestosFact", "impuestos_servicioFact", "debitnoteId", "debitnote", "invoiceTemplateId", "invoiceTemplate", "quoteId", "quote", "settlementId", "settlement", "creditnoteId", "creditnote"];
export const BuyInvoiceProductRelatedAttributes: Array<keyof EDocumentProductDataType> = ["preSavedId", "comision", "extraCost", "selected", "descriptionFact", "cantFact", "priceFact", "subtotalFact", "descuentoFact", "impuestosFact", "impuestos_servicioFact", "buyInvoiceId", "buyInvoice", "invoiceTemplateId", "invoiceTemplate", "quoteId", "quote", "settlementId", "settlement", "creditnoteId", "creditnote"];